export const getPromoTitle = (
    title: string,
    isPromoService: boolean,
    customizableTitle?: string | null
): string => (isPromoService && customizableTitle ? customizableTitle : title)
